import React, { useState , useContext, useRef} from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Grid,
  Box,
  TextField,
  MenuItem,
  Button,
  Typography,
  Paper,
  IconButton,
  LinearProgress,
  Card,
  CardMedia,
  CardActions
} from '@mui/material';
import { Delete } from '@mui/icons-material';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import AuthContext, { AuthProvider } from '../context/AuthContext';



// Your dropdown options

const applicationType = [ { value: 'registered_company', label: 'Registered Company' }, { value: 'individual', label: 'Individual' }, { value: 'group', label: 'Group Initiative' } ];
const yesNoAnswers = [ { value: 'yes', label: 'Yes' }, { value: 'no', label: 'No' } ];
const sex = [ { value: 'male', label: 'Male' }, { value: 'female', label: 'Female' } ];
const disabilityType = [ { value: 'physical_impairment', label: 'Physical Impairment' }, { value: 'visual_impairment', label: 'Visual Impairment' }, { value: 'hearing_impairment', label: 'Hearing Impairment' }, { value: 'Hearing_and_speech_impairment', label: 'Hearing and Speech Impairment' }, { value: 'others', label: 'Others' } ];
const district = [{ value: 'tema_metropolitan', label: 'Tema Metropolitan' }, { value: 'tema_west', label: 'Tema West' }, { value: 'tema_central', label: 'Tema Central' }, { value: 'ashaiman', label: 'Ashaiman' }, { value: 'kpone_katamanso', label: 'Kpone-Katamanso' }, { value: 'adentan', label: 'Adentan' }, { value: 'la_dade_kotopon', label: 'La Dade-Kotopon' }, { value: 'ledzokuku', label: 'Ledzokuku' }, { value: 'krowor', label: 'Krowor' }, { value: 'ningo_prampram', label: 'Ningo-Prampram' }, { value: 'shai_osudoku', label: 'Shai-Osudoku' }, { value: 'ada_east', label: 'Ada East' }, { value: 'ada_west', label: 'Ada West' }, { value: 'weija_gbawe', label: 'Weija Gbawe' }];
const communityType = [ { value: 'rural', label: 'Rural' }, { value: 'peri_urban', label: 'Peri-Urban' }, { value: 'urban', label: 'Urban' } ];
const educationalBackground = [ { value: 'none', label: 'None' }, { value: 'informal_only', label: 'Informal Only' }, { value: 'primary', label: 'Primary' }, { value: 'jhs', label: 'JHS' }, { value: 'shs', label: 'SHS' }, { value: 'tertiary', label: 'Tertiary' } ];
const fullTimeWork = [ { value: 'yes', label: 'Yes' }, { value: 'no', label: 'No' }, { value: 'student', label: 'Student' } ];
const workCategory = [ { value: 'self_employed', label: 'Self Employed' }, { value: 'employed_by_someone', label: 'Employed by someone' }, { value: 'apprentice', label: 'Apprentice' } ];
const sector = [{ value: 'education', label: 'Education' }, { value: 'transport', label: 'Transport' }, { value: 'finance_and_tourism', label: 'Finance & Tourism' }, { value: 'construction', label: 'Construction' }, { value: 'health', label: 'Health' }, { value: 'hospitality_and_tourism', label: 'Hospitality and Tourism' }, { value: 'agricultural', label: 'Agricultural' }, { value: 'industrial', label: 'Industrial' }, { value: 'others', label: 'Others' }]
const timeAvailability = [ { value: '1_to_5', label: '1-5 hours per week' }, { value: '6_to_10', label: '6-10 hours per week' }, { value: '11_to_15', label: '11-15 hours per week' }, { value: '>15', label: 'More than 15 hours a week' } ];
const levelOfSolution = [ { value: 'level 1', label: "Idea that I haven't tried" }, { value: 'level 2', label: 'Tried with at least 1 person' }, { value: 'level 3', label: 'Tried with more than 5 people' }, { value: 'level 4', label: 'Received funding before' } ];
// const businessNeeds = [{}]
const businessNeeds = [ { value: 'personal_mentorship', label: 'Personal Mentorship / Coaching / Guidance' }, { value: 'business_registration_fda_certification', label: 'Business Registration & FDA Certification' }, { value: 'networking_exposure', label: 'Networking & Exposure to Opportunities' }, { value: 'entrepreneurial_training', label: 'Training and Guidance to Think Entrepreneurial to See Opportunities for Growth' }, { value: 'allowance_seed_capital', label: 'Allowance & Seed Capital' }, { value: 'legal_procurement_eligibility', label: 'Legal, Procurement, Reporting and Corporate Commercial Eligibility Check' } ];


 

const FullInnovatorForm = () => {
  let {user} = useContext(AuthContext);
  let navigate = useNavigate()
  const [files, setFiles] = useState([]);
  const [uploadProgress, setUploadProgress] = useState({});
  // const [isPwD, setIsPwD] = useState('');
  const [isGroup, setIsGroup] = useState('');
  const [isPwD, setIsPwD] = useState('');
  const [disability, setDisability] = useState('');
  const [employmentStatus, setEmploymentStatus] = useState('');

  const [open, setOpen] = useState(false); // Snackbar
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setOpen(false);
  };

// REFS
  const typeRef = useRef()
  const groupMembersRef = useRef()
  const innovationHeadlineRef = useRef()
  const firstNameRef = useRef()
  const lastNameRef = useRef()
  const otherNameRef = useRef()
  const sexRef = useRef()
  const pwdStatusRef = useRef()
  const disabilityTypeRef = useRef()
  const ageRef = useRef()
  const challengeRef = useRef()
  const underlyingCauseRef = useRef()
  const peopleExperiencingRef = useRef()
  const personalExperienceRef = useRef()
  const solutionRef = useRef()
  const regionRef = useRef()
  const districtRef = useRef()
  const communityRef = useRef()
  const gpsRef = useRef()
  const emailRef = useRef()
  const communityTypeRef = useRef()
  const educationalBackgroundRef = useRef()
  const fullTimeWorkRef = useRef()
  const workCategoryRef = useRef()
  const schoolNameRef = useRef()
  const sectorRef = useRef()
  const timeAvailabilityRef = useRef()
  const businessNeedsRef = useRef()
  const whyShouldWeSelectRef = useRef()
  const jobCreationProfitRef = useRef()
  const levelOfSolutionRef = useRef()
  const previousEventRef = useRef()
  const expectationsRef = useRef()
  const extraCommentsRef = useRef()

  const handleFileChange = (e) => {
    const selected = Array.from(e.target.files);
    setFiles(prev => [...prev, ...selected]);
  };

  const handleRemove = (index) => {
    setFiles(prev => prev.filter((_, i) => i !== index));
  };

  const handleUpload = async () => {
    const fakeUpload = (file, i) => {
      return new Promise(resolve => {
        let loaded = 0;
        const interval = setInterval(() => {
          loaded += 10;
          setUploadProgress(prev => ({ ...prev, [i]: loaded }));
          if (loaded >= 100) {
            clearInterval(interval);
            resolve();
          }
        }, 200);
      });
    };
    for (let i = 0; i < files.length; i++) {
      await fakeUpload(files[i], i);
    }
    alert('Upload complete!');
  };


const SubmitForm = async () =>{
// Get
const phone_number = JSON.parse(sessionStorage.getItem('userPhone'));
// console.log('Userphone is', user)


  try {
    // const api_link = 'http://127.0.0.1:8000/add-innovator/';
    const api_link = 'https://api.mba-gris.stgafrica.org/add-innovator/'
    const response = await fetch(api_link, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({application_type: typeRef.current.value, group_members: isGroup ==='group' && groupMembersRef.current ? groupMembersRef.current.value:'',
        innovation_headline:innovationHeadlineRef.current.value, first_name:firstNameRef.current.value, last_name:lastNameRef.current.value,
        other_name:otherNameRef.current.value, phone_number:phone_number, sex:sexRef.current.value, pwd_status:pwdStatusRef.current.value, disability_type: isPwD ==='yes' && disabilityTypeRef.current ? disabilityTypeRef.current.value:'', age:ageRef.current.value, challenge_identified:challengeRef.current.value, underlying_cause:underlyingCauseRef.current.value, 
        personal_experience:personalExperienceRef.current.value, people_experiencing_challenge:peopleExperiencingRef.current.value, solution:solutionRef.current.value, region:regionRef.current.value, district:districtRef.current.value,
        community:communityRef.current.value, gps_address:gpsRef.current.value,email:emailRef.current.value, community_type:communityTypeRef.current.value,educational_background:educationalBackgroundRef.current.value,
        //  employment_status:fullTimeWork.current.value,
        employment_status:fullTimeWorkRef.current?.value, employment_type:employmentStatus === 'yes' && workCategoryRef.current ? workCategoryRef.current.value : '',
        name_of_school:employmentStatus === 'student' && schoolNameRef.current ? schoolNameRef.current.value : '',
        sector:sectorRef.current.value, time_availability:timeAvailabilityRef.current.value, level_of_solution:levelOfSolutionRef.current.value,
        business_needs:businessNeedsRef.current.value,why_should_we_select:whyShouldWeSelectRef.current.value, job_creation_profit:jobCreationProfitRef.current.value,
        similar_event:previousEventRef.current.value, expectation:expectationsRef.current.value,extra_comments:extraCommentsRef.current.value, 
        data_entry_officer:user && user.username ? user.username : 'Unauthenticated Volunteer'

        }), // <-- use state value
    });

    if (response.ok){
      sessionStorage.removeItem('userPhone');
      setSnackbarMessage('Form successfully submitted');
      setSnackbarSeverity('success');
      setOpen(true);
      setTimeout(() => {
        navigate('/innovator-phone')
      }, 1500);
      
    }else if(response.status === 401){
      alert('Numer already exeits')
      sessionStorage.removeItem('userPhone');
      
    }

    }
    catch (e) {
      // alert('An error occurred. Contact Admin for assistance.');
      setSnackbarMessage('An error occurred. Contact Admin for assistance.');
      setSnackbarSeverity('error');
      setOpen(true);
    } finally {

    }
}


  return (
    <Box sx={{ flexGrow: 1, px: { xs: 2, md: 6 }, py: 4, backgroundColor: '#f5f5f5' }}>
      <Paper elevation={3} sx={{ padding: { xs: 2, md: 4 }, borderRadius: 3 }}>
        <Typography variant="h5" mb={3} fontWeight={600} color="primary">Innovator Registration Form</Typography>
        <Grid container spacing={4}>
          {/* FORM SIDE */}
          <Grid item xs={12} md={8}>
            <Box display="flex" flexDirection="column" gap={2}>
              <TextField select onChange={(e)=>{const value = e.target.value; setIsGroup(value); if (value !== 'group') setIsGroup('');}} label="Application type" inputRef={typeRef} defaultValue="">
                {applicationType.map((option) => <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>)}
              </TextField>
              {isGroup ==='group' &&( <TextField inputRef={groupMembersRef} label="Provide names & contacts of team members" multiline rows={3} />)}                            
              <TextField label="Headline / summary of your innovation" inputRef={innovationHeadlineRef} multiline rows={3} />
              <Grid container spacing={2}>
                <Grid item xs={6}><TextField inputRef={firstNameRef} label="First name" fullWidth /></Grid>
                <Grid item xs={6}><TextField inputRef={lastNameRef} label="Last name" fullWidth /></Grid>
                <Grid item xs={12}><TextField inputRef={otherNameRef} label="Other name(s)" fullWidth /></Grid>
              </Grid>
              <TextField inputRef={sexRef} select label="Sex" defaultValue="">
                {sex.map((option) => <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>)}
              </TextField>
              <TextField
  select
  label="Are you a PwD?"
  value={isPwD}
  inputRef={pwdStatusRef}
  onChange={(e) => {
    const value = e.target.value;
    setIsPwD(value);
    if (value !== 'yes') setDisability(''); // clear if not yes
  }}
>
  {yesNoAnswers.map((option) => (
    <MenuItem key={option.value} value={option.value}>
      {option.label}
    </MenuItem>
  ))}
</TextField>

{isPwD === 'yes' && (
  <TextField
    select
    label="Disability type"
    inputRef={disabilityTypeRef}
  >
    {disabilityType.map((option) => (
      <MenuItem key={option.value} value={option.value}>
        {option.label}
      </MenuItem>
    ))}
  </TextField>
)}
              <TextField inputRef={ageRef} label="Age (years)" />
              <TextField inputRef={challengeRef} label="What challenge is your solution addressing?" multiline rows={3} />
              <TextField inputRef={underlyingCauseRef} label="Underlying cause of the challenge?" multiline rows={3} />
              <TextField inputRef={peopleExperiencingRef} label="Who experiences the challenge?" multiline rows={3} />
              <TextField inputRef={personalExperienceRef} label="Do you have personal experience?" multiline rows={3} />
              <TextField inputRef={solutionRef} label="Your solution to the challenge?" multiline rows={3} />
              <TextField inputRef={regionRef} label="Region" value="Greater Accra" />
              <TextField inputRef={districtRef} select label="District" defaultValue="">
                {district.map((option) => <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>)}
              </TextField>
              <TextField inputRef={communityRef} label="Community" />
              <TextField inputRef={emailRef} label="Email" />
              <TextField inputRef={gpsRef} label="GPS Address" />
              <TextField inputRef={communityTypeRef} select label="Community type" defaultValue="">
                {communityType.map((option) => <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>)}
              </TextField>
              <TextField inputRef={educationalBackgroundRef} select label="Educational Background" defaultValue="">
                {educationalBackground.map((option) => <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>)}
              </TextField>
              <TextField select label="Full time work?" inputRef={fullTimeWorkRef} value={employmentStatus} onChange={(e) => setEmploymentStatus(e.target.value)}>
  {fullTimeWork.map((option) => (
    <MenuItem key={option.value} value={option.value}>
      {option.label}
    </MenuItem>
  ))}
</TextField>
{employmentStatus === 'yes' && (
  <TextField select inputRef={workCategoryRef} label="Work category" defaultValue="">
    {workCategory.map((option) => (
      <MenuItem key={option.value} value={option.value}>
        {option.label}
      </MenuItem>
    ))}
  </TextField>
)}
              
              {employmentStatus ==='student' &&(<TextField inputRef={schoolNameRef} label="Name of school" />)
              }
              
              <TextField inputRef={sectorRef} select label="Sector" defaultValue="">
                {sector.map((option) => <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>)}
              </TextField>
              <TextField select inputRef={timeAvailabilityRef} label="Time Availability" defaultValue="">
                {timeAvailability.map((option) => <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>)}
              </TextField>
              <TextField select inputRef={levelOfSolutionRef} label="Level of the solution" defaultValue="">
                {levelOfSolution.map((option) => <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>)}
              </TextField>
              <TextField inputRef={businessNeedsRef} select label="What do you really need for your innovation or entrepreneurial solution?" defaultValue="">
                {businessNeeds.map((option) => <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>)}
              </TextField>
              <TextField inputRef={whyShouldWeSelectRef} label="Why should you be selected to be part of the program?" multiline rows={3} />
              <TextField inputRef={jobCreationProfitRef} label="Have you created any job/profit from your innovation?" multiline rows={3} />
              <TextField inputRef={previousEventRef} label="Previous event participation?" multiline rows={3} />
              <TextField inputRef={expectationsRef} label="Expectations" multiline rows={3} />
              <TextField inputRef={extraCommentsRef} label="Extra Comments" multiline rows={3} />
            </Box>
          </Grid>

          {/* UPLOAD SIDE */}
          {/* <Grid item xs={12} md={4}>
            <Box sx={{ p: 2, borderRadius: 2, backgroundColor: '#f0f8ff' }}>
              <Typography variant="h6" gutterBottom>Upload Media</Typography>
              <Typography variant="body2" mb={2}>Upload images and videos (preview before upload).</Typography>
              <Button variant="outlined" component="label" sx={{ mb: 2 }}>
                Add Files
                <input hidden multiple type="file" accept="image/*,video/*" onChange={handleFileChange} />
              </Button>

              <Grid container spacing={1}>
                {files.map((file, index) => {
                  const isVideo = file.type.startsWith('video');
                  const previewUrl = URL.createObjectURL(file);
                  return (
                    <Grid item xs={12} key={index}>
                      <Card sx={{ mb: 1 }}>
                        {isVideo ? (
                          <CardMedia component="video" src={previewUrl} controls sx={{ height: 180 }} />
                        ) : (
                          <CardMedia component="img" image={previewUrl} sx={{ height: 180, objectFit: 'cover' }} />
                        )}
                        <CardActions>
                          <IconButton onClick={() => handleRemove(index)}><Delete /></IconButton>
                        </CardActions>
                        {uploadProgress[index] != null && uploadProgress[index] < 100 && (
                          <LinearProgress variant="determinate" value={uploadProgress[index]} />
                        )}
                      </Card>
                    </Grid>
                  );
                })}
              </Grid>

              {files.length > 0 && (
                <Box mt={2}>
                  <Button fullWidth variant="contained" color="success" onClick={handleUpload}>
                    Upload All
                  </Button>
                </Box>
              )}
            </Box>
          </Grid> */}


        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
          <Alert onClose={handleClose} severity={snackbarSeverity} variant="filled" sx={{ width: '100%' }}>
            {snackbarMessage}
          </Alert>
        </Snackbar>
        </Grid>
          <Box mt={2}>
  <Button onClick={SubmitForm} variant="contained" color="primary" fullWidth>
    Submit
  </Button>
</Box>
      </Paper>
      
    </Box>
    
  );
};

export default FullInnovatorForm;
